document.addEventListener('turbo:load', () => document.querySelectorAll('a[data-link-disabled]').forEach((el) => {
  el.removeAttribute('data-link-disabled')
}))
